
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { partsQuantityRules } from "@common/src/utils/verify";
import { uniqBy } from "lodash";
import t from "@common/src/i18n/t";
const partsCategory = namespace("parts-category");
const inventory = namespace("inventory");
const parts = namespace("parts");
const app = namespace("app");
@Component({
  components: {}
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.select-spare-parts"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class SafetyInventoryAdd extends Vue {
  @inventory.Action queryAlertPartsList;
  @inventory.Action queryAlertList;
  @inventory.Action saveInventoryAlert;
  @inventory.Action getAlertConfig;
  @partsCategory.Action getCategoryList;
  @parts.Action getPartsBrandList;
  splitThousands = splitThousands;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  emptyToLine = emptyToLine;
  //计算属性
  get breadData() {
    return [
      { name: t("v270.safety-stock-threshold-setting"), path: "/inventory/safety-inventory-list" },
      { name: this.isAdd ? t("v270.new-spare-parts-inventory-threshold") : t("v270.edit-parts-inventory-threshold") }
    ];
  }
  get tableLength() {
    return this.form.already.length;
  }
  get isAdd() {
    return this.$route.name === "safetyInventoryAdd";
  }
  numberValidateForm = {
    age: ""
  };
  formInline = {
    user: "",
    region: ""
  };
  form = {
    already: []
  };
  showSetInventory = false;
  showParts = false;
  partsList = [];
  searchForm = {
    partsName: "",
    brandCode: "",
    categoryCode: ""
  };
  brandList: any = [];
  categoryList: any = [];
  get searchList() {
    return [
      {
        label: t("parts.name"),
        type: "input",
        value: "",
        prop: "partsName"
      },
      {
        label: t("setting.brand"),
        type: "select",
        selectList: this.brandList,
        value: "",
        prop: "brandCode"
      },
      {
        label: t("parts.category"),
        type: "cascader",
        prop: "categoryCode",
        value: "",
        options: this.categoryList,
        props: {
          label: "categoryName",
          value: "categoryCode"
        }
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.prop === "categoryCode" ? item.value[item.value.length - 1] : item.value;
      }
    });
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryAlertPartsList({
      status: "9",
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }
  created() {
    this.init();
  }

  init() {
    this.loadListData();
    if (!this.isAdd) {
      this.getAlready();
    }
    this.getCategoryList().then(data => {
      this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
    });
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.brandName,
        value: item.brandCode
      }));
    });
  }
  getAlready() {
    this.queryAlertList({
      pageNum: 1,
      pageSize: 999,
      partsCodeArray: this.$route.params.list.split(",") || []
    }).then(data => {
      this.form.already = data.data.list;
    });
  }
  saveCreateDeploy() {
    this.form.already = this.form.already.map(item => {
      return {
        ...item,
        alertQty: this.numberValidateForm.age
      };
    });
    this.showSetInventory = false;
    this.numberValidateForm.age = "";
  }
  saveSelect() {
    let newArr = this.mix_selectedRows
      .map(item => {
        return {
          ...item,
          alertQty: ""
        };
      })
      .concat(this.form.already);
    this.form.already = uniqBy(newArr, "partsCode");
    this.showParts = false;
  }
  handlePicking(index) {
    this.form.already.splice(index, 1);
  }
  submit() {
    if (
      this.form.already.some(item => {
        if (!partsQuantityRules(item.alertQty).success) {
          return true;
        }
      })
    ) {
      this.$message.warning(t("v270.safety-stock-threshold-is-greater-than-or-equal"));
      return false;
    }

    this.btnStartLoading();
    this.saveInventoryAlert({ inventoryAlertArray: [...this.form.already] })
      .then(res => {
        if (res.success) {
          this.$message.success(t("v210831.saved-successfully"));
          this.$router.push("/inventory/safety-inventory-list");
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
}
